import {
  AGREE,
  REQUEST_EXAM_DATA,
  RECEIVE_EXAM_DATA,
  REQUEST_APPEAL_SUCCESS,
  CHANGE_EXAM,
  APPROVE_EXAM,
  UPDATE_APPEAL_DATA,
  TOGGLE_EXAM_SHOW_ONLY_INCORRECT,
  INVALID_EXAM_ATTRIBUTES,
  CHANGE_GIA_ITEM,
  RESULT_NOT_READY,
  SET_EXAMS_AVAILABILITY,
  LOAD_DRAFT_EMPTY
} from '../constants';

const initialState = {
  agreementOn: false,
  loading: false,
  examList: [],
  showOnlyIncorrectByGrade: {},
  invalidExamAttributes: false,
  hasAvailableExams: false,
  resultNotReady: false
};

const examData = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_EXAM:
      return {
        ...state,
        examName: action.payload.examName,
        examId: action.payload.examId
      };
    case APPROVE_EXAM:
    case UPDATE_APPEAL_DATA:
      return {
        ...state,
        examList: action.payload
      };
    case REQUEST_EXAM_DATA:
      return {
        ...state,
        error: false,
        loading: true,
        invalidExamAttributes: false
      };
    case REQUEST_APPEAL_SUCCESS:
      return {
        ...state,
        ...initialState
      };
    case RECEIVE_EXAM_DATA:
      return {
        ...state,
        loading: false,
        resultNotReady: false,
        ...action.payload
      };
    case INVALID_EXAM_ATTRIBUTES:
      return {
        ...state,
        loading: false,
        invalidExamAttributes: true,
        resultNotReady: false
      };
    case RESULT_NOT_READY:
      return {
        ...state,
        loading: false,
        invalidExamAttributes: false,
        resultNotReady: true
      };
    case CHANGE_GIA_ITEM:
      return {
        ...state,
        examList: [],
        loading: false,
        invalidExamAttributes: false,
        hasAvailableExams: false,
        resultNotReady: false
      };
    case TOGGLE_EXAM_SHOW_ONLY_INCORRECT:
      const gradeId = action.payload;
      return {
        ...state,
        showOnlyIncorrectByGrade: {
          ...state.showOnlyIncorrectByGrade,
          [gradeId]: !state.showOnlyIncorrectByGrade[gradeId]
        }
      };
    case AGREE:
      return {
        ...state,
        agreementOn: action.payload
      };
    case SET_EXAMS_AVAILABILITY:
      return {
        ...state,
        hasAvailableExams: action.payload
      };
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default examData;
